var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _g2, _path73, _path74, _path75, _g3, _path76, _path77, _path78, _circle, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorkInProgress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 588,
    height: 451,
    viewBox: "0 0 588 451",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_154_149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M499.305 375.378H71.214C65.1357 375.378 60.1649 370.407 60.1649 364.329V88.3693C60.1649 82.291 65.1357 77.3203 71.214 77.3203H499.305C505.383 77.3203 510.354 82.291 510.354 88.3693V364.329C510.354 370.407 505.383 375.378 499.305 375.378Z",
    fill: "url(#paint0_linear_154_149)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.8 124.592H77.3927V358.35H492.8V124.592Z",
    fill: "#D8DFE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.195 106.171V84.2926C510.195 80.2827 506.913 77 502.903 77H67.2926C63.2827 77 60 80.2827 60 84.2926V106.171H510.195Z",
    fill: "#F3F4FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6943 99.1381C83.5229 99.1381 86.6267 96.0344 86.6267 92.2058C86.6267 88.3772 83.5229 85.2734 79.6943 85.2734C75.8657 85.2734 72.762 88.3772 72.762 92.2058C72.762 96.0344 75.8657 99.1381 79.6943 99.1381Z",
    fill: "#2B3081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.959 99.1381C104.787 99.1381 107.891 96.0344 107.891 92.2058C107.891 88.3772 104.787 85.2734 100.959 85.2734C97.1302 85.2734 94.0265 88.3772 94.0265 92.2058C94.0265 96.0344 97.1302 99.1381 100.959 99.1381Z",
    fill: "#EFB840"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.129 99.1381C124.958 99.1381 128.061 96.0344 128.061 92.2058C128.061 88.3772 124.958 85.2734 121.129 85.2734C117.3 85.2734 114.197 88.3772 114.197 92.2058C114.197 96.0344 117.3 99.1381 121.129 99.1381Z",
    fill: "#5ECABF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.598 145L134.959 164.217L138.277 165.899L148.916 146.682L145.598 145Z",
    fill: "#6467A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.555 148.784L128.758 146.101L121.797 152.762L119 155.444L121.797 158.12L128.758 164.781L131.555 162.104L124.594 155.444L131.555 148.784Z",
    fill: "#6467A1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152.769 148.784L155.566 146.101L162.527 152.762L165.324 155.444L162.527 158.12L155.566 164.781L152.769 162.104L159.73 155.444L152.769 148.784Z",
    fill: "#6467A1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.836 173H108V178.225H124.836V173Z",
    fill: "#AEC3FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M187.965 181.573H118.634V186.797H187.965V181.573Z",
    fill: "#999BC6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M254.792 181.573H187.963V186.797H254.792V181.573Z",
    fill: "#AEC3FA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M329.351 181.573H254.793V186.797H329.351V181.573Z",
    fill: "#F0D6A6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M373.15 181.573H329.361V186.797H373.15V181.573Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M174.735 190.153H129.856V195.378H174.735V190.153Z",
    fill: "#F0D6A6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M265.725 190.153H174.734V195.378H265.725V190.153Z",
    fill: "#999BC6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M306.868 190.153H265.725V195.378H306.868V190.153Z",
    fill: "#AEC3FA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M247.889 198.733H129.856V203.958H247.889V198.733Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M306.868 198.733H247.888V203.958H306.868V198.733Z",
    fill: "#AEC3FA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M338.105 198.733H306.868V203.958H338.105V198.733Z",
    fill: "#F0D6A6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M185.327 207.141H129.856V212.366H185.327V207.141Z",
    fill: "#A293D3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M275.817 207.141H185.326V212.366H275.817V207.141Z",
    fill: "#F0D6A6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M315.927 207.141H275.816V212.366H315.927V207.141Z",
    fill: "#999BC6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M190.74 219.077H128.485V224.301H190.74V219.077Z",
    fill: "#ADDBD6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M257.909 219.077H190.741V224.301H257.909V219.077Z",
    fill: "#A293D3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M331.771 219.077H257.907V224.301H331.771V219.077Z",
    fill: "#F0D6A6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M362.565 219.077H331.772V224.301H362.565V219.077Z",
    fill: "#AEC3FA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M204.802 227.342H140.11V232.566H204.802V227.342Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M298.02 227.342H237.337V232.566H298.02V227.342Z",
    fill: "#999BC6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M407.219 227.342H298.012V232.566H407.219V227.342Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M237.336 227.342H204.801V232.566H237.336V227.342Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M219.629 235.734H139.464V240.959H219.629V235.734Z",
    fill: "#AEC3FA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M247.889 235.734H219.629V240.959H247.889V235.734Z",
    fill: "#ADDBD6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M314.944 235.734H247.888V240.959H314.944V235.734Z",
    fill: "#999BC6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M367.89 244.127H291.775V249.352H367.89V244.127Z",
    fill: "#ADDBD6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M419.224 244.127H367.891V249.352H419.224V244.127Z",
    fill: "#999BC6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M467.165 244.127H419.229V249.352H467.165V244.127Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M203.567 244.127H139.464V249.352H203.567V244.127Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M247.243 244.127H203.567V249.352H247.243V244.127Z",
    fill: "#A293D3"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M291.781 244.127H247.241V249.352H291.781V244.127Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M185.328 304.616H129.857V309.841H185.328V304.616Z",
    fill: "#AEC3FA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M275.819 304.616H185.328V309.841H275.819V304.616Z",
    fill: "#F0D6A6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M315.928 304.616H275.817V309.841H315.928V304.616Z",
    fill: "#999BC6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M193.144 294.55H130.889V299.775H193.144V294.55Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M260.313 294.55H193.145V299.775H260.313V294.55Z",
    fill: "#AEC3FA"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M334.178 294.55H260.314V299.775H334.178V294.55Z",
    fill: "#F0D6A6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M364.969 294.55H334.176V299.775H364.969V294.55Z",
    fill: "#AEC3FA"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M358.273 265.769H282.158V270.994H358.273V265.769Z",
    fill: "#AEC3FA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M195.187 284.791H130.495V290.016H195.187V284.791Z",
    fill: "#A293D3"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M227.712 284.791H195.177V290.016H227.712V284.791Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M288.396 284.791H227.714V290.016H288.396V284.791Z",
    fill: "#999BC6"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M397.602 284.791H288.395V290.016H397.602V284.791Z",
    fill: "#ADDBD6"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M210.005 275.655H129.84V280.88H210.005V275.655Z",
    fill: "#AEC3FA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M238.274 275.655H210.014V280.88H238.274V275.655Z",
    fill: "#A293D3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M305.328 275.655H238.273V280.88H305.328V275.655Z",
    fill: "#ADDBD6"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M193.943 265.769H129.84V270.994H193.943V265.769Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M237.626 265.769H193.949V270.994H237.626V265.769Z",
    fill: "#AEC3FA"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M282.161 265.769H237.621V270.994H282.161V265.769Z",
    fill: "#A293D3"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M146.694 254.494H129.857V259.718H146.694V254.494Z",
    fill: "#A293D3"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M193.781 339.253H129.089V344.478H193.781V339.253Z",
    fill: "#ADDBD6"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M226.316 339.253H193.781V344.478H226.316V339.253Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M287 339.253H226.317V344.478H287V339.253Z",
    fill: "#999BC6"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M396.199 339.253H286.992V344.478H396.199V339.253Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M208.61 330.117H128.445V335.342H208.61V330.117Z",
    fill: "#AEC3FA"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M236.868 330.117H208.608V335.342H236.868V330.117Z",
    fill: "#ADDBD6"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M303.926 330.117H236.871V335.342H303.926V330.117Z",
    fill: "#999BC6"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M146.694 318.009H129.858V323.233H146.694V318.009Z",
    fill: "#F0D6A6"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M216.471 408H161V413.225H216.471V408Z",
    fill: "#AEC3FA"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M338.111 403H298V408.225H338.111V403Z",
    fill: "#999BC6"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M282 393H236V398H282V393Z",
    fill: "#F0D6A6"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M357.433 364.275H281.318V369.5H357.433V364.275Z",
    fill: "#AEC3FA"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M226.872 383.297H194.336V388.522H226.872V383.297Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M298 383H266V388H298V383Z",
    fill: "#999BC6"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M237.434 374.162H209.174V379.386H237.434V374.162Z",
    fill: "#A293D3"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M281.32 364.275H236.781V369.5H281.32V364.275Z",
    fill: "#A293D3"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M366 441H337V446H366V441Z",
    fill: "#F0D6A6"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M360 429H318V434H360V429Z",
    fill: "#ADDBD6"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M308.26 418H280V423.225H308.26V418Z",
    fill: "#A293D3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter1_f_154_149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M554.315 52.0002L561.16 43.1063L556.164 36.6668L545.852 41.0932C544.233 39.4863 542.515 37.9853 540.702 36.5903L543.686 25.7775L536.629 21.6984L528.754 29.6741C526.453 28.7147 524.069 27.9083 521.603 27.2726L520.173 16.0183L512.08 15L507.908 25.5479C505.6 25.5538 503.317 25.7128 501.074 26.0071L495.548 16.2537L487.673 18.3551L487.744 29.5682C485.413 30.5276 483.159 31.6519 480.999 32.9233L472.106 26.0777L465.667 31.075L470.093 41.3875C468.486 43.0062 466.985 44.725 465.59 46.5379L454.778 43.5536L450.7 50.6111L458.675 58.4867C457.715 60.7882 456.909 63.1721 456.273 65.6384L445.02 67.0687L444.002 75.1563L454.549 79.3295C454.555 81.6369 454.714 83.9207 455.008 86.1633L445.255 91.6904L447.357 99.566L458.569 99.4954C459.528 101.826 460.652 104.081 461.923 106.241L455.079 115.135L460.075 121.574L470.387 117.148C472.005 118.755 473.724 120.256 475.537 121.651L472.553 132.464L479.61 136.543L487.485 128.567C489.786 129.526 492.169 130.333 494.636 130.969L496.066 142.223L504.153 143.241L508.325 132.693C510.633 132.687 512.916 132.528 515.159 132.234L520.685 141.987L528.56 139.886L528.489 128.673C530.82 127.714 533.074 126.589 535.234 125.318L544.127 132.163L550.566 127.166L546.14 116.854C547.747 115.235 549.248 113.516 550.643 111.703L561.455 114.688L565.533 107.63L557.57 99.7603C558.53 97.4588 559.336 95.0749 559.971 92.6086L571.225 91.1783L572.243 83.0908L561.696 78.9175C561.69 76.6101 561.531 74.3263 561.237 72.0837L570.989 66.5566L568.888 58.681L557.676 58.7516C556.711 56.4148 555.587 54.1604 554.315 52.0002ZM549.007 84.2739C546.164 106.859 525.553 122.863 502.975 120.02C480.392 117.177 464.389 96.5641 467.232 73.9849C470.075 51.3998 490.686 35.3954 513.263 38.2384C535.846 41.0814 551.849 61.6947 549.007 84.2739Z",
    fill: "black"
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M555.052 51.3042L561.623 42.7679L556.826 36.5875L546.929 40.8359C545.375 39.2936 543.725 37.853 541.985 36.5141L544.85 26.1361L538.076 22.2211L530.517 29.876C528.308 28.9552 526.02 28.1812 523.653 27.5711L522.28 16.7695L514.512 15.7921L510.507 25.9158C508.292 25.9215 506.1 26.074 503.948 26.3565L498.643 16.9954L491.084 19.0123L491.152 29.7744C488.915 30.6952 486.751 31.7742 484.678 32.9945L476.142 26.4243L469.961 31.2206L474.21 41.1183C472.667 42.6719 471.227 44.3215 469.888 46.0615L459.51 43.1973L455.595 49.9709L463.25 57.5298C462.329 59.7387 461.555 62.0267 460.945 64.3938L450.143 65.7666L449.166 73.5289L459.29 77.5343C459.295 79.7488 459.448 81.9408 459.73 84.0932L450.369 89.398L452.386 96.9569L463.148 96.8891C464.069 99.1262 465.148 101.29 466.368 103.363L459.798 111.9L464.594 118.08L474.492 113.832C476.046 115.374 477.695 116.814 479.435 118.153L476.571 128.531L483.345 132.446L490.904 124.791C493.112 125.712 495.4 126.486 497.768 127.096L499.14 137.898L506.903 138.875L510.908 128.752C513.123 128.746 515.315 128.593 517.467 128.311L522.772 137.672L530.331 135.655L530.263 124.893C532.5 123.972 534.664 122.893 536.737 121.673L545.273 128.243L551.454 123.447L547.205 113.549C548.748 111.996 550.188 110.346 551.527 108.606L561.905 111.47L565.82 104.697L558.176 97.1433C559.097 94.9344 559.871 92.6464 560.481 90.2793L571.283 88.9065L572.26 81.1442L562.137 77.1388C562.131 74.9243 561.978 72.7323 561.696 70.5799L571.057 65.2751L569.04 57.7162L558.278 57.784C557.352 55.5412 556.273 53.3775 555.052 51.3042ZM549.957 82.2798C547.228 103.956 527.444 119.317 505.773 116.589C484.096 113.86 468.735 94.0757 471.464 72.4046C474.193 50.7279 493.977 35.3672 515.648 38.0959C537.325 40.8246 552.685 60.6087 549.957 82.2798Z",
    fill: "#FAD590"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M561.623 42.7679L555.052 51.3042C556.273 53.3775 557.352 55.5412 558.278 57.784L569.04 57.7162L571.057 65.2751L561.696 70.5799C561.978 72.7323 562.131 74.9243 562.137 77.1388L572.26 81.1442L571.283 88.9065L560.481 90.2793C559.871 92.6464 559.097 94.9344 558.176 97.1433L565.82 104.697L561.905 111.47L551.527 108.606C550.188 110.346 548.748 111.996 547.205 113.549L551.454 123.447L545.273 128.243L536.737 121.673C534.664 122.893 532.5 123.972 530.263 124.893L530.331 135.655L522.772 137.672L517.467 128.311C515.315 128.593 513.123 128.746 510.908 128.752L506.903 138.875L499.14 137.898L497.768 127.096C495.4 126.486 493.112 125.712 490.904 124.791L483.345 132.446L476.571 128.531L479.435 118.153C477.695 116.814 476.046 115.374 474.492 113.832C478.037 113.565 486.24 112.718 490.693 111.47C495.186 114.108 500.276 115.897 505.773 116.589C527.444 119.317 547.228 103.956 549.957 82.2798C551.239 72.093 548.525 62.3231 543.036 54.5457C544.754 50.4782 546.347 43.711 546.929 40.8359L556.826 36.5875L561.623 42.7679Z",
    fill: "#EDB347"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M555.293 77.1433C555.293 101.792 535.311 121.773 510.663 121.773C486.014 121.773 466.032 101.792 466.032 77.1433C466.032 52.4947 486.014 32.5131 510.663 32.5131C535.311 32.5131 555.293 52.4947 555.293 77.1433ZM473.99 77.1433C473.99 97.3972 490.409 113.816 510.663 113.816C530.917 113.816 547.336 97.3972 547.336 77.1433C547.336 56.8893 530.917 40.4702 510.663 40.4702C490.409 40.4702 473.99 56.8893 473.99 77.1433Z",
    fill: "#BD903B"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter2_f_154_149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.675 104.452L398.503 99.702L394.035 103.169L397.106 110.325C395.991 111.448 394.95 112.64 393.982 113.898L386.479 111.828L383.648 116.725L389.183 122.189C388.517 123.786 387.957 125.44 387.516 127.151L379.707 128.144L379 133.759L386.319 136.655C386.323 138.256 386.434 139.841 386.638 141.397L379.87 145.232L381.328 150.696L389.109 150.647C389.775 152.264 390.555 153.829 391.437 155.327L386.687 161.498L390.155 165.966L397.311 162.895C398.434 164.01 399.627 165.052 400.885 166.02L398.814 173.522L403.711 176.352L409.176 170.818C410.773 171.484 412.427 172.044 414.139 172.485L415.131 180.293L420.743 181L423.639 173.681C425.24 173.677 426.825 173.567 428.381 173.363L432.217 180.13L437.682 178.672L437.633 170.892C439.25 170.226 440.814 169.446 442.313 168.564L448.485 173.314L452.953 169.846L449.882 162.691C450.997 161.568 452.038 160.375 453.006 159.117L460.51 161.188L463.34 156.291L457.806 150.827C458.471 149.23 459.031 147.576 459.472 145.865L467.282 144.872L467.988 139.261L460.669 136.365C460.665 134.764 460.555 133.179 460.35 131.623L467.118 127.788L465.66 122.324L457.879 122.373C457.213 120.756 456.433 119.191 455.551 117.692L460.301 111.521L456.834 107.053L449.678 110.125C448.554 109.01 447.362 107.968 446.104 107L448.175 99.4978L443.277 96.6676L437.816 102.193C436.219 101.528 434.565 100.968 432.854 100.527L431.861 92.7183L426.249 92.0117L423.353 99.3304C421.752 99.3345 420.167 99.4447 418.611 99.6489L414.776 92.8816L409.311 94.3396L409.36 102.12C407.738 102.79 406.174 103.57 404.675 104.452ZM427.07 108.136C442.742 110.108 453.848 124.411 451.875 140.077C449.902 155.748 435.598 166.853 419.93 164.88C404.258 162.907 393.153 148.605 395.125 132.938C397.098 117.268 411.402 106.163 427.07 108.136Z",
    fill: "black"
  }))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M404.192 103.941L398.269 99.3817L393.98 102.71L396.928 109.578C395.858 110.656 394.858 111.801 393.929 113.008L386.728 111.021L384.011 115.721L389.323 120.966C388.684 122.499 388.147 124.087 387.723 125.729L380.228 126.682L379.55 132.072L386.575 134.852C386.579 136.388 386.684 137.909 386.88 139.403L380.385 143.084L381.784 148.329L389.252 148.282C389.891 149.835 390.64 151.336 391.487 152.775L386.927 158.698L390.256 162.987L397.124 160.039C398.202 161.109 399.347 162.109 400.554 163.038L398.567 170.239L403.267 172.956L408.512 167.644C410.045 168.283 411.633 168.82 413.275 169.243L414.228 176.739L419.614 177.417L422.393 170.392C423.93 170.388 425.451 170.282 426.945 170.086L430.626 176.582L435.871 175.182L435.824 167.715C437.376 167.076 438.878 166.327 440.317 165.48L446.24 170.039L450.529 166.711L447.581 159.843C448.651 158.765 449.651 157.62 450.58 156.413L457.781 158.4L460.498 153.7L455.186 148.455C455.825 146.922 456.362 145.334 456.785 143.692L464.281 142.739L464.959 137.353L457.934 134.573C457.93 133.037 457.824 131.516 457.628 130.022L464.124 126.341L462.724 121.096L455.256 121.143C454.617 119.59 453.869 118.089 453.022 116.65L457.581 110.727L454.253 106.438L447.385 109.386C446.307 108.316 445.162 107.316 443.954 106.387L445.942 99.1857L441.242 96.469L436 101.773C434.468 101.134 432.88 100.597 431.237 100.174L430.285 92.6782L424.898 92L422.119 99.025C420.582 99.0289 419.061 99.1348 417.568 99.3308L413.887 92.835L408.641 94.2345L408.688 101.702C407.132 102.345 405.631 103.094 404.192 103.941ZM425.686 107.477C440.728 109.37 451.387 123.099 449.494 138.137C447.6 153.178 433.872 163.837 418.834 161.944C403.792 160.051 393.133 146.322 395.027 131.284C396.92 116.242 410.649 105.583 425.686 107.477Z",
    fill: "#141A79"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398.269 99.3817L404.192 103.941C405.631 103.094 407.132 102.345 408.688 101.702L408.641 94.2345L413.887 92.835L417.568 99.3308C419.061 99.1348 420.582 99.0289 422.119 99.025L424.898 92L430.285 92.6782L431.237 100.174C432.88 100.597 434.468 101.134 436 101.773L441.242 96.469L445.942 99.1857L443.954 106.387C445.162 107.316 446.307 108.316 447.385 109.386L454.253 106.438L457.581 110.727L453.022 116.65C453.869 118.089 454.617 119.59 455.256 121.143L462.724 121.096L464.124 126.341L457.628 130.022C457.824 131.516 457.93 133.037 457.934 134.573L464.959 137.353L464.281 142.739L456.785 143.692C456.362 145.334 455.825 146.922 455.186 148.455L460.498 153.7L457.781 158.4L450.58 156.413C449.651 157.62 448.651 158.765 447.581 159.843C447.395 157.383 446.808 151.69 445.942 148.601C447.772 145.483 449.014 141.951 449.494 138.137C451.387 123.099 440.728 109.37 425.686 107.477C418.618 106.587 411.838 108.47 406.441 112.279C403.619 111.087 398.923 109.982 396.928 109.578L393.98 102.71L398.269 99.3817Z",
    fill: "#2B33BC"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M422.122 103.772C439.226 103.772 453.092 117.637 453.092 134.741C453.092 151.845 439.226 165.711 422.122 165.711C405.018 165.711 391.153 151.845 391.153 134.741C391.153 117.637 405.018 103.772 422.122 103.772ZM422.122 160.189C436.177 160.189 447.57 148.796 447.57 134.741C447.57 120.687 436.177 109.293 422.122 109.293C408.068 109.293 396.674 120.687 396.674 134.741C396.674 148.796 408.068 160.189 422.122 160.189Z",
    fill: "#071D54"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 510.305,
    cy: 76.3027,
    r: 26.974,
    fill: "#5ECABF"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter3_i_154_149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M521.541 69.2735C523.651 69.2735 525.361 67.6042 525.361 65.5451C525.361 63.4859 523.651 61.8167 521.541 61.8167C519.431 61.8167 517.72 63.4859 517.72 65.5451C517.72 67.6042 519.431 69.2735 521.541 69.2735Z",
    fill: "#0D806C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.542 91.8875C520.859 92.0234 521.201 92.0936 521.547 92.0936C521.893 92.0936 522.236 92.0234 522.552 91.8875C522.981 91.704 523.327 91.375 523.526 90.9615L523.614 90.7909L530.731 74.1228C530.731 74.1228 532.217 70.7843 528.596 71.6859C528.596 71.6859 521.304 75.3412 514.287 71.5884L514.012 71.4666C513.45 71.3204 511.677 71.0036 512.127 73.3308C512.14 73.4189 512.165 73.505 512.202 73.5867L519.468 90.7787C519.534 90.9138 519.609 91.0441 519.693 91.1686C519.874 91.5036 520.177 91.7602 520.542 91.8875Z",
    fill: "#0D806C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.628 69.2735C501.738 69.2735 503.449 67.6042 503.449 65.5451C503.449 63.4859 501.738 61.8167 499.628 61.8167C497.518 61.8167 495.808 63.4859 495.808 65.5451C495.808 67.6042 497.518 69.2735 499.628 69.2735Z",
    fill: "#0D806C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.54 71.5509C500.223 71.4149 499.881 71.3448 499.535 71.3448C499.189 71.3448 498.846 71.4149 498.529 71.5509C498.099 71.7256 497.751 72.0517 497.556 72.4647L497.468 72.6353L490.351 89.3522C490.351 89.3522 488.865 92.6907 492.486 91.789C492.486 91.789 499.778 88.1337 506.795 91.8865C506.881 91.9393 506.973 91.9803 507.07 92.0084C507.632 92.1546 509.405 92.4714 508.955 90.1442C508.944 90.0596 508.918 89.9773 508.88 89.9005L501.614 72.6596C501.548 72.5246 501.473 72.3943 501.389 72.2697C501.204 71.9377 500.903 71.6823 500.54 71.5509Z",
    fill: "#0D806C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_154_149",
    x: 0,
    y: 21,
    width: 570.354,
    height: 418.378,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.00784314 0 0 0 0 0.270588 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_154_149"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_154_149",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_154_149",
    x: 429.002,
    y: 0,
    width: 158.241,
    height: 158.241,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_154_149"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_154_149",
    x: 364,
    y: 77.0117,
    width: 118.988,
    height: 118.988,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_154_149"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_154_149",
    x: 490.049,
    y: 61.8167,
    width: 40.9833,
    height: 30.2934,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_154_149"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_154_149",
    x1: 52.265,
    y1: 96.299,
    x2: 503.112,
    y2: 369.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkInProgress);
export default __webpack_public_path__ + "static/media/workInProgress.7042b61d5568c3c59a6e0329e1680b46.svg";
export { ForwardRef as ReactComponent };